import { FC } from 'react';

import Code from '../../../Shared/Code';
import ContentGenerator from '../../../Shared/ContentGenerator';

import { useVideoContext } from '../../VideoController/VideoController.context';

import { Content } from '../../../../types/tour';

export type Props = {
  content: Content;
  setComplete: () => void;
  goNext: () => void;
};

const codeSample = (callId) => `
  const [call] = useState(() => client.call('default', '${callId}'));
`;

export const Step3: FC<Props> = ({ setComplete, content }) => {
  const { state, setCall } = useVideoContext();

  const run = async () => {
    await setCall();
    setComplete();
  };

  return (
    <ContentGenerator
      content={content}
      code={
        <Code
          language="jsx"
          footer={{ label: 'Create Call', run, disabled: !!state.call }}
        >
          {codeSample(state.callId)}
        </Code>
      }
    />
  );
};
